import toastr from 'toastr'
import { dateFormat } from 'filters'
import pagination from 'components/pagination'
import { editableText } from 'components/editable'
import { hasPermits } from 'directives'

const directives = {
  hasPermits
}

const components = {
  pagination,
  editableText,
}

const filters = {
  dateFormat
}

const watch = {
  activeTab (n) {
    if (n && this.ancillary && this.ancillary.ancillary_type === 'esim') {
      this.loading = true;
      Promise.all([
        this.loadEsimReservations(1),
      ]).then(() => {
        this.loading = false;
      });
    }
  },

  testingMode (n) {
    if (this.activeTab && this.ancillary && this.ancillary.ancillary_type === 'esim') {
      this.loadEsimReservations(1)
    }
  },

  formData (n, o) {
    if (n == o) return;

    this.form = n;
  }
}


const computed = {
  esim_reservations () {
    return _.cloneDeep(this.$store.state.channels.active.esim_reservations);
  },

  errors () {
    if (this.$store.state.channels.errors) {
      return this.$store.state.channels.errors.errors;
    }
    return {}
  }
}

const methods = {
  toggleEsimReservations (index) {
    this.$set(this.showEsimReservations, index, !this.showEsimReservations[index]);
    
    // Load eSIM reservations if showing and not already loaded
    if (this.showEsimReservations[index] && (!this.esim_reservations || !this.esim_reservations.data)) {
      this.loadEsimReservations();
    }
  },

  loadEsimReservations (page = 1) {
    this.loading = true;
    return this.$store.dispatch('channels.getEsimReservations', {
      id: this.$route.params.id,
      params: {
        page,
        _sort: '-id',
        testing: this.testingMode ? 1 : 0,
      }
    }).then(() => {
      this.loading = false;
    });
  },

  markupValueChanged (event, index) {
    let errors = {};
    this.$emit('throwErrors', errors);
    if (isNaN(event.value)) {
      let key = `channels.${index}.coupon_limit`;
      errors[key] = [];
      errors[key].push("Coupon Limit can only be a number")
      this.$emit('throwErrors', errors);
      return;
    }

    event.startLoading();
    let value = Number(event.value);
    this.formData.ancillaries[index]['markup_value'] = value;

    event.stopLoading();
    event.close();
  },

  reslabFeeValueChanged (event, index) {
    let errors = {};
    this.$emit('throwErrors', errors);
    if (isNaN(event.value)) {
      let key = `channels.${index}.coupon_limit`;
      errors[key] = [];
      errors[key].push("Coupon Limit can only be a number")
      this.$emit('throwErrors', errors);
      return;
    }

    event.startLoading();
    let value = Number(event.value);
    this.formData.ancillaries[index]['reslab_fee_value'] = value;

    event.stopLoading();
    event.close();
  }
}

export default {
  name: 'esim-ancillary',
  props: ['formData', 'activeTab', 'ancillary', 'ancillaryIndex', 'testingMode'],
  components,
  computed,
  filters,
  methods,
  watch,
  directives,
  data () {
    return {
      loading: false,
      showEsimReservations: {}
    }
  },
  created() {
    this.$nextTick(() => {
      if (this.activeTab && this.ancillary && this.ancillary.ancillary_type === 'esim') {
        this.loadEsimReservations();
      }
    });
  }
} 